import React from 'react';
/*

MESSAGES.JSX

  This file is a convenient location for managing copy within the app.
  The majority of the text within the app is included this file, with
  the exception of configurations for things like grids + forms.

  The idea is that future copy writers, solution owners, or translators
  will be able to more easily modify this file's content to improve
  phrasing or engage in internationalization

*/

export default {
  // Global
  Form: {
    emailLabel: 'Email: ',
    phoneLabel: 'Phone: ',
    faxLabel: 'Fax: ',
    submitButton: 'Submit',
    continueButton: 'Continue',
    backButton: 'Back',
    cancelButton: 'Cancel',
    requiredFields: 'Required fields are marked with an asterisk',
    required: 'Required',
    save: 'Save',
  },
  Errors: {
    missingAuthToken: 'Could not make request because no auth token was found',
    missingQueryArg:
      'Could not make request because the query argument is missing',
    serverError:
      'There was a problem with the server during submission, please try again in a few minutes. If the problem persist...',
    submissionError: 'There was a problem during submission, please try again',
    missingRecipients: 'Please Add Recipients',
    generalError:
      'Oops, Something Went Wrong Please Try Again. If The Problem Persists Please Contact Support',
    rfqNotFound: 'Oops, We Cannot Find The RFQ You Are Looking For',
    quoteMissing: 'Oops, We Cannot Find The Qoute You Are Looking For',
    missingPermissionsContract:
      'You Do Not Have Permission to View and Edit Contracts',
  },
  Success: {
    updatedOrganizaton: 'Organization updated!',
    createdOrganization: 'Organization created!',
    deletedOrganization: 'Organization deleted!',
    updatedUser: 'User updated!',
    createdUser: 'User created!',
    deletedUser: 'User Deleted!',
    updatedTooling: 'Tooling updated!',
    createdTool: 'Tooling created!',
    deletedTool: 'Tooling deleted!',
    addMatchsSettings: 'Added bid match settings!',
    updatedMatchSettings: 'Updated bid matching settings!',
  },
  Filters: {
    issueDate: 'Issue Date',
    returnDate: 'Close Date',
    quantity: 'Quantity',
  },
  // Components
  FilterGroup: {
    viewAll: 'View All',
    viewLess: 'View Less',
  },
  // Component - Solicitations Menu
  SolicitationsMenu: {
    clearAll: 'Clear Filters',
    header: 'Filter Your Results',
    suspectCastingSwitch: 'Suspect Castings',
  },
  // Solictiation table header tooltips
  SolicitationsToolTips: {
    date: 'Solicitation issue date',
    solicitationNum: 'Solicitation number',
    closeDate: 'Solicitation close date',
    status: '',
    nsn: 'National stock number of part being requested by solicitation',
    lastAward: 'Last Award Date',
    myPartNumber:
      'Populates the part number if your organization has a matching tooling record',
    toolingCage: 'Tooling CAGE',
    description: 'Description of part being requested in solicitation',
    qty: 'The quantity of parts being requested based on unit of issue',
    ui: 'The unit of issue of the parts being requested',
    estValue: 'Estimated dollar value of solicitation',
    srva:
      'Supplier Requirements Visibility Application - DLA requirement quantity projected for next two years',
    type: 'Casting, Forging, or Suspect Casting',
    amc:
      'Acquisition Method Code (first digit) Acquisition Method Suffix Code (second digit)',
    material: 'Part material',
    method: 'Casting Method',
  },
  // Component - Top Nav
  TopNav: {
    brandText: 'ICON',
    item1: 'Item Search',
    procurementHistory: 'Procurement history',
    item2: 'About',
    item3: 'Contact',
    item4: 'Solicitations',
    item5: 'Supplier Capabilities',
    userDropdown: {
      register: 'Register',
      pdmi: 'PDMI Credentials',
      bidMatching: 'Bid Matching',
      notifications: 'Notifications',
      accountOrginization: 'Organization Administration',
      toolingManagement: 'Tooling Management',
      superAdminHome: 'Super Admin Home',
    },
    supportDropdown: {
      support: 'Support',
      iconfaqs: 'FAQs',
      registration: 'Registration',
      cfolders: 'PDMI cFolders',
      help: 'Help',
      pnHelp: 'Part Numbers',
      cdHelp: 'Code Definitions',
      solHelp: 'Solicitations',
      relNotesHelp: 'Release Notes',
      newslettersHelp: 'Newsletters',
    },
  },
  // Component - Notification Card
  NotificationCard: {
    minIssueDate: 'From Issue Date',
    maxIssueDate: 'To Issue Date',
    minDueDate: 'From Due Date',
    maxDueDate: 'To Due Date',
  },
  // Component - Admin Menu

  AdminMenu: {
    header: 'Organization Administration',
  },
  // Component - Notification Card
  ViewUsersGrid: {
    noDataText: 'No results. Please update your search criteria and try again.',
  },
  ViewPendingRequest: {
    noDataText: 'No results. Please update your search criteria and try again.',
  },
  // Component - PDMI Form
  PdmiForm: {
    username: 'PDMI Username',
    password: 'Password',
    passwordConfirmation: 'Password Confirmation',
  },
  // Form - NewOrganization
  OrganizationForm: {
    organizationName: 'Organization Name',
    cageCode: 'CAGE Code',
    address1: ' Address 1',
    address2: 'Address 2',
    address3: 'Address 3',
    city: 'City',
    state: 'State/Province',
    stateZip: 'State & Zip',
    websiteUrl: 'Website URL',
    zipcode: 'ZIP/Postal Code',
    country: 'Country',
    contactName: 'Contact Name',
    contactEmail: 'Contact Email',
    contactPhone: 'Contact Phone',
    contactFax: 'Contact Fax',
    materialCastings: 'Material Castings',
    castingProcess: 'Casting Process',
    forgingProcess: 'Forging Process',
    industryType: 'Industry Type',
    naics: 'NAICS Codes',
    industryAssociations: 'Industry Affiliations',
    associationValidations: 'Industry Affiliations',

  },
  // Pages
  HomePage: {
    mainHeader: 'Integrated Casting Order Network',
    subHeader:
      'Driving value to the Defense Logistics Agency (DLA) and domestic manufacturers b' +
      'y providing innovative procurement solutions for defense and military related me' +
      'tal castings.',
    subSubHeader:
      '*Please note some features available on the legacy site may not yet be enabled o' +
      'n the new site but will be added soon. We ask for your patience during this tran' +
      'sition.*',
    headerButton: 'Tooling Locations',
    info1: {
      header: 'New Business Opportunities',
      text:
        'ICON enables you to find the right opportunities through its integration with ma' +
        'jor defense procurement sites like FBO, DIBBS, NECO, and ASFI',
    },
    info2: {
      header: 'Comprehensive Data',
      text:
        'ICON is a comprehensive source for the information you need to determine which o' +
        'pportunities are right for your company',
    },
    info3: {
      header: 'Tailored Solution',
      text:
        'ICON delivers only casting solicitations matched to your manufacturing capabilit' +
        'ies.  Advanced filtering and sorting features save you valuable time and resourc' +
        'es',
    },
    info4: {
      header: 'THE ICON PORTAL',
      text: 'The Integrated Casting Order Network (ICON) is a secure, web-based portal developed to strengthen the Department of Defense (DOD) and Defense Logistics Agency (DLA) supply chain by connecting qualified manufacturers with opportunities to produce critical cast, forged, and machined components. ICON streamlines the sourcing, communication, and procurement processes to ensure timely delivery of mission-essential parts - directly supporting Warfighter Readiness. Originally focused on the casting industry, ICON has evolved into a powerful, all encompassing manufacturing network that now includes forging and machining capabilities. The platform provides suppliers with access to current DOD solicitations, bid matching tools, and opportunities aligned with their manufacturing capabilities. ICON also enables suppliers to build and manage detailed company profiles, update their production capabilities, and receive targeted opportunities based on specific materials, processes, and capacities. Buyers benefit from enhanced visibility into a qualified and diverse supplier base, promoting efficiency, competition, and faster sourcing. By modern technologies, standardized data exchange, and value-added protocols, ICON ensures a secure, efficient, and user-friendly experience. Its intuitive interface and streamlined workflows make it easier for both government and industry users to collaborate effectively. ICON continues to expand its functionality - with new enhancements, a refreshed look and feel, and integration of forging industry features. Together, these advancements reinforce ICON mission: to provide a unified, modernized solution that supports manufacturing excellence, strengthens the defense industrial base, and advances the readiness of the Warfighter.',
    },
    quote:
      '"AMC\'s Emergent Metal Casting Solutions (EMCS) Program is sponsored by the Defens' +
      'e Logistics Agency Troop Support, Philadelphia, PA and the Defense Logistics Age' +
      'ncy Research & Development (R&D) Office, Ft. Belvoir, VA"',
  },
  Registration: {
    header1: 'Find Your Organization',
    subheader: "Enter your email address and your organization's CAGE code",
    header2: 'Create Account',
    subheader2: 'Update/Enter your information',
    header3: 'Review your Organization',
    subheader3: 'verify that this is the organization you wish to join',
    header4: 'Request to Join',
    subheader4:
      'Your request will be viewed and approved by the appropriate admins',
    alreadyReg: 'Already Registered?',
    user: {
      name: 'Full Name',
      phone: 'Phone',
      Email: 'Email',
    },
    org: {
      organizationType: {
        member: 'Member',
        government: 'Government',
      },
      cage: 'CAGE Code',
      orgName: 'Organization Name',
      address: {
        address1: 'Address 1',
        address2: 'Address 2',
        address3: 'Address 3',
        city: 'City',
        state: 'State/Province',
        zipcode: 'ZIP/Postal Code',
        country: 'Country',
        websiteUrl: 'Website URL',
      },
    },
  },
  PdmiCredentials: {
    header: 'PDMI Password Update',
  },
  Tooling: {
    header: 'Request Tooling Locations',
    text:
      'Due to the proprietary information of the tooling database, unrestricted access ' +
      'is only granted to Department of Defense Personnel. However, any defense contrac' +
      'tor is able to make an inquiry to source casting suppliers and defense-related p' +
      'atterns using the following form. NFFS Staff will perform searches free of charge' +
      '. NFFS Staff will respond by e-mail within 3 business days with the status of yo' +
      'ur inquiry.',
    text2:
      'For each inquiry, the solicitation number associated with the part is required a' +
      'nd usually consists of at least 13 characters (SPM4A610Q1234 or SPM4A6-10-Q-1234' +
      '). In addition, your contact information must be submitted so that if a pattern ' +
      'is identified, NFFS can direct the supplier to contact you. All further communic' +
      'ations resulting from a search should be directed to the responding supplier. NF' +
      'FS assumes no further involvement and/or responsibility for the resulting busine' +
      'ss relationship. In addition, both parties must conduct such relationships with ' +
      'the full and proper adherence to the rights of ownership of customer provided to' +
      'oling.',
  },
  ProcurementHistory: {
    header: 'Search Procurement History',
    loading: 'Loading',
  },

  ToolingSearch: {
    header: 'Search Tooling, Inventory and Procurement History',
    col1: 'NSN',
    col2: 'Part Name',
    col3: 'Finished Part Number',
    col4: 'Tooling Location',
    loading: 'Loading',
  },
  ToolingMgmt: {
    header: 'Tooling Management',
    loading: 'Loading tools...',
  },
  About: {
    header: 'About ICON',
    section1: {
      text:
        (
          <div>
            <p>
              ICON is a web-based portal designed to connect the casting, machining and forging industries with opportunities to make critical parts for the Department of Defense. ICON streamlines the procurement process for cast and forged metal parts needed for military applications. It acts as a marketplace connecting DLA&apos;s procurement needs with foundries, forgers and machine shops capable of producing these parts.
            </p>
            <p>
              ICON is funded by the Defense Logistics Agency (DLA) and the Industrial Base Analysis and Sustainment program (IBAS) and developed and operated by the Non-Ferrous Founders&apos; Society (NFFS).
            </p>
          </div>
        ),
    },
    section2: {
      header: 'Background',
      text: (
        <div>
          <p>
            The Integrated Casting, Forging, and Machining Order Network (ICON) is a modernized web-based portal designed to connect the manufacturing base, including foundries, forgers, and machine shops—directly with Department of Defense (DOD) opportunities. ICON streamlines the government procurement process by aligning solicitations with industry capabilities, ultimately enhancing warfighter readiness and strengthening the defense supply chain.
          </p>
          <p>
            Originally developed through the American Metalcasting Consortium (AMC) as a tooling search and bid-matching tool, ICON has since evolved into a comprehensive bid management portal. The platform now provides a single, centralized source for suppliers to identify, review, and respond to government solicitations across multiple manufacturing sectors.
          </p>
          <p>
            By integrating the <strong>Automated Contract Evaluation (ACE) Tool</strong> – A powerful, integrated capability that supports smarter, faster bid decisions by analyzing solicitation data and offering actionable insights, with the Supplier capability databases, tooling resources, and solicitation management functions, ICON enables businesses to discover and compete for opportunities that match their production strengths.
          </p>
        </div>
      ),
      text2: (
        <div>
          <p>
            Through these expanded features, ICON has become more than a procurement portal—it is a strategic enabler of efficiency, cost savings, and readiness. By linking government buyers with qualified manufacturers, ICON strengthens the defense supply chain and ensures that America&apos;s industrial base is better positioned to deliver the critical parts and capabilities needed by the warfighter.
          </p>
          <p>
            By transforming from a casting-only tool into a multi-industry manufacturing portal, ICON has become a critical enabler of efficiency, cost savings, and readiness for the Department of Defense. It ensures that suppliers of all sizes have the visibility, information, and resources they need to compete successfully, while giving government program offices faster access to qualified manufacturers. ICON represents the next generation of defense procurement support—an integrated, automated, and scalable solution that strengthens the partnership between government buyers and the U.S. manufacturing base.
          </p>
        </div>
      ),
      text3: '',
    },
  },

  cfolders: {
    drw_popup: 'Please Click ',
    drw_popup1: ' Proceed ',
    drw_popup2:
      'to continue, ICON is temporarily redirecting our users to the PDMI website. Enter your PDMI',
    drw_popup3: ' Username ',
    drw_popup4: 'and ',
    drw_popup5: ' Password ',
    drw_popup6:
      'to log in to the site. You will then be able to complete your download of the Zip file containing all technical documentation for the solicitation, including the requested drawing number(s). Please refer to the',
    drw_popup7: ' cFolders How To Page ',
    drw_popup8:
      'for more instructions on cFolder files including options for viewing different file formats (e.g., C4).',
  },

  Contact: {
    header: 'Contact Us',
    section1: {
      text:
        "The data development and maintenance is managed by the Non-Ferrous Founders' Soc" +
        'iety, a North American foundry trade association, as part of the American Metalc' +
        'asting Consortium’s  Casting Solutions for Readiness program.',
    },
    section2: {
      header: 'Please direct all inquiries to:',
    },
    address: {
      name: 'ICON SUPPORT TEAM',
      company: "Non-Ferrous Founders' Society",
      line1: 'TBA',
      line2: 'TBA',
      phone: '(847) 268-4876',
      email: 'support@iconportal.com',
    },
  },
  LoginFailure: {
    header: 'Login Failure',
    section1: {
      text:
        "Unfortunately there was an error logging in. Please try again. If the problem persists please contact support using the email form below."
    },
    section2: {
      header: 'Contact details:',
    },
    address: {
      name: 'ICON SUPPORT TEAM',
      company: "Non-Ferrous Founders' Society",
      line1: 'TBA',
      line2: 'TBA',
      phone: '(847) 268-4876',
      email: 'support@iconportal.com',
    },
  },
  SolicitationDetail: {
    header: 'Solicitation Details ',
    subheader: id => ['NSN#', <span> {id} </span>],
    InfoTableHeader: 'Info',
    RecentSolicitationHeader: 'Recent Solicitations',
    DrawingTableHeader: 'Drawings',
    ProcHistHeader: 'Procurement History',
    TechnicalCharHeader: 'Technical Characteristics',
    DescriptionHeader: 'Item Description',
    PackingInfoHeader: 'Packaging Information',
    solicitationId: 'Solicitation Id: ',
    castingType: 'Casting Type: ',
    nsnPart: 'NSN: ',
    fscCode: 'FSC Code: ',
    fscName: 'FSC Name: ',
    nomenclature: 'Nomenclature: ',
    techDocsLink: 'Tech Docs Link: ',
    issueDate: 'Date Issued: ',
    purchaseRequestNumber: 'Purchase Request Number: ',
    quantity: 'Quantity',
    solicitationAttributes: 'Solicitation Attributes: ',
    attachmentLinks: 'Attachment Links: ',
  },
  ToolingLocationSearch: {
    header: 'Please search for something',
  },
  BidMatchSettings: {
    header: 'Bid Matching Settings',
    subheader:
      'Manage your bid matching preferences by selecting from the options below.',
    noCardsFound:
      'No Bid Matching Settings Found'
  },
  SolicitationsSearch: {
    loading: 'Searching solicitations...',
  },
  SolicitationsSearchBar: {
    editBidMatching: 'Edit Bid Matching Settings...',
    hitsCount: hits => `${hits} solicitations found`,
  },

  accountAdmin: {
    header: 'Organization Administration',
  },
  superAdminHome: {
    header: 'Super Admin Home',
  },
  ViewUsers: {
    loading: 'Loading Users...',
    header: 'Organization Management',
  },
  AddUser: {
    addUser: 'Add a new user',
    requiredFields: 'Required fields are marked with an asterisk',
    required: 'Required',
    pageisLoading: 'Page is loading',
    emailInvalid: 'Please enter a valid email address',
    phoneNumberInvalid:
      'Please enter a valid phone number formatted as xxx-xxx-xxxx',
    fullName: 'Full Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    faxNumber: 'Fax Number',
    iconStatus: 'Icon Status',
    approved: 'Approved',
    blocked: 'Blocked',
    accountUser: 'Account User',
    accountAdmin: 'Account Admin',
    accountSuper: 'Super Admin',
    submit: 'Submit',
    // phoneNumberFormat: '999-999-9999',
  },
  EditUser: {
    header: 'Edit User',
    pageisLoading: 'Page is loading',
    emailInvalid: 'Please enter a valid email address',
    phoneNumberInvalid:
      'Please enter a valid phone number formatted as xxx-xxx-xxxx',
    fullName: 'Full Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    faxNumber: 'Fax Number',
    iconStatus: 'Icon Status',
    approved: 'Approved',
    blocked: 'Blocked',
    accountUser: 'Account User',
    accountAdmin: 'Account Admin',
    submit: 'Submit',
  },
  AddProduct: {
    header: 'Add Product',
  },
  EditTool: {
    header: 'Edit Product',
  },
  AddOrganization: {
    header: 'Add New Organization',
  },
  ToolingLocationsDetail: {
    header: 'Tooling Details',
    // subheader: niin => ['NIIN# ', <span>{niin}</span>],
    table1Header: 'Part Information',
    table2Header: 'Tooling Location & Technical Information',
  },
  ViewDetailsModal: {
    orgIconStatus: 'Organization Icon Status',
    orgType: 'Organization Type',
    userStatus: 'User Status',
    userType: 'User Type',
  },
  SupplierSearch: {
    Aluminum: 'Aluminum',
    Copper: 'Copper',
    Iron: 'Iron',
    MMC: 'Metal',
    Other: 'Other Non-Ferrous',
    Steel: 'Steel',
    Weight: 'Weight Range',
    Search: 'Search Suppliers',
  },
  ToolTips: {
    open: 'Solicitations with a status of "Open"',
    closed: 'Solicitations with a status of "Closed"',
    awarded: 'Solicitations with a status of "Awarded"',
    cancelled: 'Solicitations with a status of "Cancelled"',
    matches:
      "Solicitations matching your organization's bid match setting or for which your organization has a matching tooling record",
    flagged: 'Solicitations that you have flagged for follow up',
    tqb: 'Solicitations that you moved to "To be Quoted"',
    ip: 'Solicitations that you moved to "In Process"',
    archived: 'Solicitations that you moved to "Archived"',
    ace: 'Solicitations that you have sent to ACE (Automated Contract Evaluation)',
  },
  Footer: {
    browserRequirements:
      'Use of ICON requires Internet Explorer 11, Mozilla Firefox or Google Chrome, with cookies and Javascript enabled',
  },
};



// WEBPACK FOOTER //
// ./src/config/messages.jsx